import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/products/shared/state/auth-context';
import { getMfaAssuranceStatus } from '@/products/shared/utils/mfa';

export const MFA_AAL_QUERY_KEY = 'mfa-aal';

export const useMfaAssurance = () => {
  const { user, accessToken } = useAuth();

  const query = useQuery({
    queryKey: [MFA_AAL_QUERY_KEY, user?.id, accessToken],
    queryFn: async () => {
      const { data, error } = await getMfaAssuranceStatus();
      if (error) {
        throw new Error(error.message);
      }
      return data;
    },
    enabled: Boolean(user),
    staleTime: 0,
    retry: 1,
  });

  return {
    isLoading: Boolean(user) && (query.isLoading || query.isFetching) && query.data == null,
    needsChallenge: query.data?.needsChallenge === true,
    currentLevel: query.data?.currentLevel ?? null,
    nextLevel: query.data?.nextLevel ?? null,
    error: query.error instanceof Error ? query.error.message : null,
    refetch: query.refetch,
  };
};
